import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryModalForm } from '../../../../../../models/bary-modal-form';
import { BaryModalEvent } from '../../../../../../models/bary-modal-event';
import { Merchandise, MerchandiseControls } from '../../../../../../models/merchandise.model';
import { OfferService } from '../../../../../../services/offer.service';
import { OfferViewDTO } from '../../../../../../models/offer-view-dto.type';
import { Transporter } from '../../../../../../models/transporter.model';
import { BaryFormFactoryService } from '../../../../../../services/bary-form-factory.service';
import { CurrentDataService } from '../../../../../../services/current-data-service';
import { NgIf } from '@angular/common';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { BaryTitleComponent } from '../../../bary-title/bary-title.component';
import { BaryInputTextComponent } from '../../../bary-input-text/bary-input-text.component';
import { BaryInputSwitchComponent } from '../../../bary-input-switch/bary-input-switch.component';
import { BaryInputMultiSelectComponent } from '../../../bary-input-multi-select/bary-input-multi-select.component';
import { BaryButtonComponent } from '../../../bary-button/bary-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'jhi-modal-add-or-update-merchandise',
  templateUrl: './modal-add-or-update-merchandise.component.html',
  standalone: true,
  imports: [NgIf, TranslateDirective, BaryTitleComponent, BaryInputTextComponent, BaryInputSwitchComponent, BaryInputMultiSelectComponent, BaryButtonComponent, TranslateModule],
})
export class ModalAddOrUpdateMerchandiseComponent extends BaryModalForm implements OnInit {
  #fb = inject(FormBuilder);
  #modalRef = inject(MDBModalRef);
  #bff = inject(BaryFormFactoryService);
  #offerService = inject(OfferService);
  #currentDataService = inject(CurrentDataService);

  override model: Merchandise = new Merchandise();

  public type: 'create' | 'update' = 'create';
  public controls?: MerchandiseControls;
  public isGlobal?: boolean;
  public options: Array<{ label: string; value: any }> = [];
  public transporter!: Transporter;

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.#currentDataService.getCurrentTransporter().subscribe((transporter: Transporter): void => {
      this.transporter = transporter;
      this.controls = this.#bff.makeMerchandiseControls(this.model);

      if (this.isGlobal) {
        this.controls.newName.disable();
      }

      this.modalForm = this.#fb.group(this.controls);

      this.#offerService.getTransporterOffersWithName(this.transporter?.id!).subscribe((it: OfferViewDTO[]): void => {
        this.options = it.map((offer: OfferViewDTO) => ({ label: offer.name!, value: offer }));
      });
    });
  }

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }

  public changeActif($event: any): void {
    this.model.forceQuotation = !!$event;
  }

  override handleSubmit(): void {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      this.focusOnFirstError();
    } else {
      this.model.newName = this.controls?.newName.value;
      this.model.offers = this.controls?.offers.value;
      this.action.next(new BaryModalEvent({ submit: true, value: this.model.serialize() }));
      this.#modalRef.hide();
    }
  }
}
